import React, { useEffect } from 'react'
import { Modal } from 'react-responsive-modal'
import * as profileActions from '../../containers/SignInPage/actions'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState as ProfileStateType } from '../../containers/SignInPage/types'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import isEmail from 'validator/lib/isEmail'
import { Form, Field } from 'react-final-form'
import usePrevious from '../../hooks/usePrevious'

// Components
import Loading from '../../components/Loading'
import notification from '../../components/Notification'

// Styles
import './styles.scss'

// Icons
import IconLogo from './images/iconLogo'
import IconClose from './images/iconClose'
import IconCopy from './images/iconCopy'

export default ({
  modal,
  typeInvite,
  isReverse,
  alertDescription,
  onClose,
  connectionType,
}: {
  modal: boolean
  typeInvite: string
  isReverse: boolean
  alertDescription: string
  onClose: () => void
  connectionType?: string
}) => {
  const dispatch = useDispatch()

  const { isProcessReferralLink, isProcessEmailInvite, referralLink, error } =
    useSelector((state: { profile: ProfileStateType }) => state.profile)

  const prevIsProcessEmailInvite = usePrevious(isProcessEmailInvite)

  useEffect(() => {
    if (prevIsProcessEmailInvite && !isProcessEmailInvite) {
      if (error) {
        notification('error', '', error)
      } else {
        notification(
          <IconCopy />,
          '',
          'Приглашение отправлено!',
          () => null,
          () => null,
          () => null,
          'invite'
        )
        onClose()
      }
    }
  }, [isProcessEmailInvite])

  const { REACT_APP_URL, REACT_APP_URI_PREFIX } = process.env

  useEffect(() => {
    dispatch(profileActions.clearReferralLink())
  }, [])

  const handleCopyLink = () => {
    notification(
      <IconCopy />,
      'Ссылка скопирована!',
      alertDescription,
      () => null,
      () => null,
      () => null,
      'invite'
    )
    onClose()
  }

  const requiredEmail = (value: string) =>
    value && isEmail(value) ? undefined : 'error'

  const handleSendEmail = (values: { [field: string]: string }) => {
    if (referralLink) {
      const { email, text } = values
      dispatch(profileActions.sendEmailInvite(referralLink.code, email, text))
    }
  }

  const modalStyles = {
    overlay: {
      background: 'rgba(0, 0, 0, 0.4)',
    },
    modal: {
      width: 565,
      borderRadius: 50,
      padding: 0,
      margin: '2em',
      boxShadow: 'unset',
      overflow: 'unset',
      outline: 0,
    },
  }

  return (
    <Modal
      open={modal}
      showCloseIcon={false}
      onClose={onClose}
      onAnimationEnd={() => {
        if (referralLink) {
          dispatch(profileActions.clearReferralLink())
        } else {
          dispatch(
            profileActions.fetchReferralLink(
              typeInvite,
              `${REACT_APP_URL}${REACT_APP_URI_PREFIX}/signin`,
              +isReverse,
              connectionType
            )
          )
        }
      }}
      styles={modalStyles}
      center={true}
    >
      <div className={'modal-invite-friend'}>
        <div className={'modal-invite-friend__close'}>
          <IconClose onClick={onClose} />
        </div>
        <IconLogo />
        <div className={'modal-invite-friend__description'}>
          открытый генеалогический
          <br />
          онлайн-курс для школьников
        </div>
        <div className={'modal-invite-friend__title'}>
          Отправить приглашение
        </div>
        {isProcessReferralLink || !referralLink ? (
          <div className={'modal-invite-friend__copy'}>
            <Loading color={'rgba(244, 186, 39, 0.5)'} width={60} height={60} />
          </div>
        ) : (
          <CopyToClipboard text={referralLink.url} onCopy={handleCopyLink}>
            <div className={'modal-invite-friend__copy'}>
              <span className={'title'}>Скопировать ссылку</span>
              <span className={'url'}>{referralLink.url}</span>
            </div>
          </CopyToClipboard>
        )}
        <div className={'email-hr'}>Или</div>
        <Form onSubmit={handleSendEmail}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className={'modal-invite-friend__form'}>
                <div className={'title'}>Отправить письмо</div>
                <div className={'field'}>
                  <Field
                    name={'email'}
                    component={'input'}
                    validate={requiredEmail}
                  >
                    {({ input, meta }) => (
                      <input
                        type={'text'}
                        placeholder={'* E-mail'}
                        onChange={input.onChange}
                        style={
                          meta.error === 'error' && meta.touched
                            ? { border: '1px solid red' }
                            : {}
                        }
                      />
                    )}
                  </Field>
                </div>
                <Field
                  type={'textarea'}
                  name={'text'}
                  placeholder={'Текст приглашения'}
                  component={'textarea'}
                />
                <button
                  type={'submit'}
                  disabled={isProcessReferralLink || isProcessEmailInvite}
                >
                  {isProcessEmailInvite ? (
                    <Loading style={{ margin: 10 }} width={64} height={64} />
                  ) : (
                    'Отправить'
                  )}
                </button>
              </div>
            </form>
          )}
        </Form>
      </div>
    </Modal>
  )
}
